import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchFlightTypes,
  fetchAirlineConfigurations,
  createAirlineConfiguration,
  deleteAirlineConfiguration,
  createFlightType,
  checkAirlineConfigurationInUse,
} from "../../services/airlineConfigurations";
import { toast } from "react-toastify";

export const getFlightTypes = createAsyncThunk(
  "airlineConfigurations/getFlightTypes",
  async (_, thunkAPI) => {
    try {
      const { data, error } = await fetchFlightTypes();
      if (error) throw error;
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
);

export const getAirlineConfigurations = createAsyncThunk(
  "airlineConfigurations/getAirlineConfigurations",
  async (airlineId, thunkAPI) => {
    try {
      const { data, error } = await fetchAirlineConfigurations(airlineId);
      if (error) throw error;
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
);

export const addAirlineConfiguration = createAsyncThunk(
  "airlineConfigurations/addAirlineConfiguration",
  async (config, thunkAPI) => {
    try {
      const result = await toast.promise(
        createAirlineConfiguration(config).then((res) => {
          if (res.error) throw res.error;
          return res;
        }),
        {
          pending: "Creando configuración...",
          success: "Configuración creada exitosamente",
          error: {
            render({ data }) {
              return `Error: ${data?.message || 'Error al crear la configuración'}`;
            }
          }
        }
      );

      return result.data[0];
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
);

export const removeAirlineConfiguration = createAsyncThunk(
  "airlineConfigurations/removeAirlineConfiguration",
  async (id, thunkAPI) => {
    try {
      // 1. Verificar si está siendo usado
      const { data: usageData, error: usageError } = await checkAirlineConfigurationInUse(id);
      if (usageError) throw usageError;
      
      if (usageData && usageData.length > 0) {
        // Extraer nombres de clientes para el mensaje
        const clientNames = usageData
          .map(r => r.reservations?.clients?.name)
          .filter(Boolean)
          .join(', ');
          
        const errorMsg = `En uso por ${usageData.length} reserva(s) (${clientNames || 'clientes desconocidos'}). Quítala de esas reservas primero.`;
        toast.error(errorMsg);
        return thunkAPI.rejectWithValue({ error: errorMsg });
      }

      await toast.promise(
        deleteAirlineConfiguration(id).then((res) => {
          if (res.error) throw res.error;
          return res;
        }),
        {
          pending: "Eliminando configuración...",
          success: "Configuración eliminada",
          error: {
            render({ data }) {
              return `Error: ${data?.message || 'Error al eliminar'}`;
            }
          }
        }
      );
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
);

export const addFlightType = createAsyncThunk(
  "airlineConfigurations/addFlightType",
  async ({ name, description }, thunkAPI) => {
    try {
      const result = await toast.promise(
        createFlightType(name, description).then((res) => {
          if (res.error) throw res.error;
          return res;
        }),
        {
          pending: "Creando tipo de vuelo...",
          success: "Tipo de vuelo creado",
          error: {
            render({ data }) {
              return `Error: ${data?.message || 'Error al crear tipo de vuelo'}`;
            }
          }
        }
      );

      return result.data[0];
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
);
